import React from "react";
import Main from "./main";
import Home from "./Home1";
function Home1(){
    return(
        <Main/>
    );
};
export default Home1;